module.exports = __webpack_public_path__ + "img/video_page_play.6f7c54201d910ce01d730841976f6e7c.svg";